import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/garrettgeesink/garrettgeesink.github.io'
      className='link footer__link'
    >
      Created By Garrett Geesink
    </a>
  </footer>
)

export default Footer
